import {
  FETCH_LIST,
  FETCH_RETAIL_LIST,
  LIST_FETCHED,
  SHOW_INVT_DIALOG,
  HIDE_INVT_DIALOG,
  UPDATED,
  TOGGLE_LOADING,
  SET_ACTIVE_STATE,
  SHOW_LINK_LIST_DIALOG,
  SHOW_MANAGER_LIST_DIALOG,
  SHOW_RETAIL_LINK_LIST_DIALOG,
  SHOW_RETAIL_MANAGER_LIST_DIALOG,
  SHOW_BIND_DIALOG,
  SHOW_RETAIL_BIND_DIALOG,
} from './actionTypes'

export const fetchList = (params, tenantId) => ({
  type: FETCH_LIST,
  payload: {
    tenantId,
    params
  }
})

export const fetchRetailList = (params, retailId) => ({
  type: FETCH_RETAIL_LIST,
  payload: {
    retailId,
    params
  }
})

export const listFetched = result => ({
  type: LIST_FETCHED,
  payload: result
})

export const showInvtDialog = params => ({
  type: SHOW_INVT_DIALOG,
  payload: { params }
})

export const hideInvtDialog = () => ({
  type: HIDE_INVT_DIALOG
})

export const showLinkListDialog = params => ({
  type: SHOW_LINK_LIST_DIALOG,
  payload: { params }
})

export const showManagerListDialog = params => ({
  type: SHOW_MANAGER_LIST_DIALOG,
  payload: { params }
})

export const showRetailLinkListDialog = params => ({
  type: SHOW_RETAIL_LINK_LIST_DIALOG,
  payload: { params }
})

export const showRetailManagerListDialog = params => ({
  type: SHOW_RETAIL_MANAGER_LIST_DIALOG,
  payload: { params }
})

export const showBindDialog = params => ({
  type: SHOW_BIND_DIALOG,
  payload: { params }
})

export const showRetailBindDialog = params => ({
  type: SHOW_RETAIL_BIND_DIALOG,
  payload: { params }
})

export const toggleLoading = () => ({
  type: TOGGLE_LOADING
})

export const updated = (id, data) => ({
  type: UPDATED,
  payload: { id, data }
})

export const setActiveState = (id, isActive) => ({
  type: SET_ACTIVE_STATE,
  payload: { id, isActive }
})
